<template>
    <MonthPickerPrev
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-left"
        size="xs"
        tooltipText="Previous year"
    />
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { MonthPickerPrevProps } from 'reka-ui';
import { MonthPickerPrev, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<MonthPickerPrevProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
